import { COUNTRIES } from '@constants/countries';
import { TicketHolderFormField } from '@domain/ticket-holder-form-field';

const mapDefaultValues = (slug: string, isoCode: string) => {
  if (slug === 'nationality') return isoCode;
  if (slug === 'phone') return COUNTRIES[isoCode].dialCode;
  if (slug === 'gender') return 'not-to-say';
  return '';
};

export const createDefaultValues = (fields: TicketHolderFormField[], isoCode: string, defaultChannelId?: string) =>
  fields.reduce<{ [x: string]: string | undefined }>(
    (acc, field) => {
      acc[field.slug] = mapDefaultValues(field.slug, isoCode);
      return acc;
    },
    {
      channelId: defaultChannelId,
    }
  );
